import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
`

export const Label = styled.label`
  font-size: 12px;
  font-weight: 700;
  line-height: 24px;
  margin: 0 0 4px 16px;
`

export const FormSelect = styled.div`
  position: relative;
  max-width: 661px;
  width: 100%;
`

export const Select = styled.select`
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background-color: #FCF8EF;
  border: none;
  border-radius: 10px;
  font-weight: 300;
  height: 45px;
  outline: none;
  padding: 13px 16px;
  width: 100%;

  &::placeholder {
    color: #7E8691;
    font-size: 16px;
    line-height: 24px;
    font-style: italic;
    max-width: 250px;
  }
`

export const ArrowContainer = styled.figure`
  bottom: 0;
  height: fit-content;
  margin: auto 0;
  pointer-events: none;
  position: absolute;
  right: 20px;
  top: 0;
  width: fit-content;
`
